const Footer = () => {
  return (
    <footer className='flex justify-center text-sm py-4 bg-primary-400'>
      <p>Copyright {new Date().getFullYear()}&copy;. Christian Rápalo.</p>
    </footer>
  );
};

export default Footer;